import { m as motion, AnimatePresence } from 'framer-motion';
import { Text } from '@etg/wings';
import { price as priceUtils } from '@eti/utils';
import { CABIN_UPGRADE } from '../../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const AnimatePrice = _ref => {
  let {
    textVariant,
    totalPrice
  } = _ref;
  const isValidPrice = typeof totalPrice === 'number' && !Number.isNaN(totalPrice);
  return isValidPrice ? /*#__PURE__*/_jsx(AnimatePresence, {
    children: /*#__PURE__*/_jsx(motion.pre, {
      animate: {
        scale: 1,
        opacity: 1
      },
      initial: {
        scale: 0.95,
        opacity: 0.5
      },
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 100
      },
      children: /*#__PURE__*/_jsx(Text, {
        "data-testid": `${CABIN_UPGRADE.name}-drawer-summary-price`,
        variant: textVariant,
        children: priceUtils.formatPrice(totalPrice)
      })
    }, totalPrice)
  }) : null;
};
export default AnimatePrice;
//# sourceMappingURL=AnimatePrice.js.map